/* tslint:disable */
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HttpResponse} from '@angular/common/http';
import {Inject} from '@angular/core';
import {Injectable} from '@angular/core';
import {API_HOST} from '../api-host';
import {GetLearningPathsResponse} from './get-learning-paths.response';
import {GetLearningPathsRequest} from './get-learning-paths.request';
@Injectable()
export class LearningPathsGateway {
  constructor(private readonly _httpClient: HttpClient, @Inject(API_HOST) private readonly _apiHost: string) {}

  getLearningPaths(
    queryParams: GetLearningPathsRequest,
    options?: Parameters<HttpClient['request']>[2],
  ): Observable<GetLearningPathsResponse> {
    return this._httpClient.request('get', this._apiHost + '/learning_paths', {
      ...options,
      observe: 'body',
      params: (queryParams as unknown) as {[param: string]: string | string[]},
    });
  }
}
